import { render, staticRenderFns } from "./MetodosPagov5.vue?vue&type=template&id=15f2f05e&scoped=true"
import script from "./MetodosPagov5.vue?vue&type=script&lang=js"
export * from "./MetodosPagov5.vue?vue&type=script&lang=js"
import style0 from "./MetodosPagov5.vue?vue&type=style&index=0&id=15f2f05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f2f05e",
  null
  
)

export default component.exports